/**
 * useRitualImages Hook
 * Fetches ritual data including images and videos using React Query
 */

import type { RitualDetail } from "../services/ritual.service"
import { useRitual } from "./useRitual"

export function useRitualImages(ritualId: string) {
  // Fetch the full ritual data which includes images and videos
  const { data, isLoading } = useRitual(ritualId)

  return {
    data: data as RitualDetail | undefined,
    isLoading,
  }
}
